export default __webpack_public_path__ + "static/media/target-loading.3c6ce56d.gif";